import React, { Component } from "react";
import { Field } from "./FieldComponent";
import { STATUS } from "../constant";
import { InnerLoader } from "./Loader";
import { isValidArray, clearDebounce } from "../helper";
import { isFunction, debounce } from "lodash";

export class SearchComponentWithApi extends Component {
  state = {};
  debounceSearch = null;

  componentDidMount() {
    const { value } = this.props;
    this.setState({
      value
    });
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const { value } = nextProps;
    this.setState({
      value: value
    });
  }

  onChange = (value, key, element) => {
    const { replacePattern, onChange, delay = 1000 } = this.props;
    const replaceText = replacePattern
      ? value.replace(replacePattern, "")
      : value.replace(/[\\]/, "");
    this.setState(
      {
        value: replaceText,
        sorting: STATUS.LOADING,
        isSearching: !!replaceText
      },
      () => {
        clearDebounce(this.debounceSearch);
        this.debounceSearch = debounce(() => {
          isFunction(onChange) && onChange({ searchedText: replaceText }, key);
          this.setState({ sorting: STATUS.SUCCESS });
        }, delay);
        this.debounceSearch();
      }
    );
  };
  onBlur = value => {
    const { onBlur } = this.props;
    onBlur(value);
  };
  OtherPPBlur = value => {
    const { OtherPPBlur } = this.props;
    OtherPPBlur(value);
  };
  render() {
    const {
      isLoading,
      delay,
      disabled,
      className,
      isMinistry,
      additionalPP
    } = this.props;
    const { sorting, value } = this.state;
    return (
      <React.Fragment>
        <InnerLoader
          loading={sorting === STATUS.LOADING || isLoading === STATUS.LOADING}
          style={{
            position: "absolute",
            right: "4px",
            zIndex: "10000",
            top: "1px",
            display: "inline-block",
            width: "auto"
          }}
        />
        <Field
          data-test="search-box"
          placeholder={` ${
            isMinistry === true ? "-Select Ministry-" : "Search"
          }`}
          {...this.props}
          onChange={this.onChange}
          class={className}
          value={value}
          delay={delay || 1000}
          name="####################"
          disabled={disabled}
          onBlur={additionalPP ? this.OtherPPBlur : this.onBlur}
        />
      </React.Fragment>
    );
  }
}
